<template>
  <div>
    <p id="dashboardItemTitle">Activity Report</p>
    <div class="columns mt-3">

      <div class="column is-3">
        <b-field custom-class="is-small"
                 :type="invalidUserRole == '' ? '' : 'is-danger'"
                 :message="invalidUserRole">
          <b-select placeholder="Select a User Role" expanded v-model="formData.UserRole" @input="getUserList();resetInvalidStatus('invalidUserRole')" >
            <option
                v-for="option in UserRole "
                :value="option.id"
                :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field custom-class="is-small"
                 :type="invalidUserName == '' ? '' : 'is-danger'"
                 :message="invalidUserName">
          <b-select placeholder="Select a Username" expanded v-model="formData.UserName" @input="resetInvalidStatus('invalidUserName')" >
            <option
                v-for="option in UserList "
                :value="option.id"
                :key="option.id">
              {{ option.username }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-2">
        <b-field
            custom-class="is-small"
            :type="invalidDateRange == '' ? '' : 'is-danger'"
            :message="invalidDateRange">
          <b-datepicker
              :range="true"
              :date-creator="generateDate"
              :max-date="new Date()"
              placeholder="Click to select..."
              icon="calendar-today"
              trap-focus
              v-model="selectedDateRange"
              @input="resetInvalidStatus('invalidDateRange')">
          </b-datepicker>
        </b-field>
      </div>

      <div class="column is-2">
        <b-field>
          <b-button class="is-dark" icon-left="file-clock" @click="validateAndSubmit()">Generate Report</b-button>
        </b-field>
      </div>

      <div class="column">
<!--          <b-button class="mt-3" :loading="xlsxDownloading" @click="ReportDownload('XLSX')" :disabled="!exportButtonsEnabled" type="is-link" size="is-small is-outlined" icon-right="microsoft-excel"></b-button>-->
          <b-button class="ml-2 is-outlined" :loading="pdfDownloading" @click="ReportDownload('PDF')" :disabled="!exportButtonsEnabled" type="is-link"  icon-right="adobe-acrobat">Download</b-button>
      </div>

    </div>
    <div style="margin-top: 30px">
      <section v-if="!isLoading">
        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>
        <b-table
            v-else
            :data="tableRows"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">

          <b-table-column field="id" label="ID" sortable numeric v-slot="props" width="10" cellClass="has-text-left" >
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="username" label="Username" sortable  v-slot="props" width="50" cellClass="has-text-left" >
            {{ props.row.username }}
          </b-table-column>

          <b-table-column field="name" label="Name" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="contact_number" label="Contact" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.contact_number }}
          </b-table-column>

          <b-table-column field="email" label="Email" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.email }}
          </b-table-column>

          <b-table-column field="description" label="Description"  v-slot="props" width="200" cellClass="has-text-left">
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="timestamp" label="Timestamp" sortable width="20"  v-slot="props" cellClass="has-text-left">
            {{ DateFormat(props.row.timestamp) }}
          </b-table-column>

        </b-table>

      </section>

    </div>
  </div>
</template>
<script>

import axios from "axios";
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'


export default {

  name:'activity-report',

  data(){
    return{
      tableRows:[], // to store pending documents
      isLoading:false,
      UserList:[],

      showTemplateDeleteModal:false,
      selectedDateRange:null,

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      template_id:'',
      maxDate:null,

      invalidDateRange:'',
      invalidUserName:'',
      invalidUserRole:'',

      UserRole:[
        {id:1,name:'Department Admin'},
        {id:2,name:'Internal Staff'}
      ],

      formData: {
        start_date: '',
        end_date: '',
        UserRole: null,
        UserName:null,
      },

      xlsxDownloading:false,
      pdfDownloading:false,
      exportButtonsEnabled:false,
    }

  },

  methods:{

    DateFormat:function(date)
    {
      //date formatting
      var d = new Date(date)
      var datestring = d.getFullYear() + "-"+ (d.getMonth()+1) + "-"+ d.getDate();

      console.log(datestring);

      //hours formatting
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;

      var dateTime = datestring +' : '+ strTime
      return dateTime

      // console.log('dateformat js'+datestring);
    },

    filterTableData:function (sourceData, fields, keyword){

      var outputArray = [];
      sourceData.forEach(function(row){
        let pushed = false
        fields.forEach(function(fieldName){
          if(String(row[fieldName]).match(RegExp(keyword, "i")) && !pushed){
            outputArray.push(row)
            pushed = true
          }
        });
      });

      return outputArray
    },


    getUserList:function (){
      var comp = this

      let formData = new FormData()
      formData.append('user_role',comp.formData.UserRole)

      axios.post(comp.$base_url+'/agent/getuserList',formData)
          .then(function (response) {
            console.log(response.data)
            comp.UserList = response.data.data
          })
          .catch(function (error) {
            console.log(error)
            comp.$buefy.toast.open({
              message: "Failed to get filter data",
              type: "is-danger",
            });
          });
    },

    generateDate: function(){

      var date = new Date()
      return date

    },

    resetInvalidStatus: function(key){
      this[key] = ''
    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
    },

    validateForm: function(){
      var formIsValid = true


      if(this.selectedDateRange == null){
        this.invalidDateRange = 'This field cannot left blanks'
        formIsValid = false
      }

      if(this.formData.UserName == null){
        this.invalidUserName = 'This field cannot left blanks'
        formIsValid = false
      }

      if(this.formData.UserRole == null){
        this.invalidUserRole = 'This field cannot left blanks'
        formIsValid = false
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    ReportDownload:function (fileType){
      var component = this

      if(fileType=='PDF'){ component.pdfDownloading = true }
      else{ component.xlsxDownloading = true }

      let formData = new FormData()
      formData.append('file_type', fileType)
      formData.append('auth_token',component.$root.agentAuthToken)

      axios.post(component.$base_url+'/agent/reportDownload',formData)
          .then(function (response) {
            console.log(response)
            if(fileType=='PDF'){
              component.pdfDownloading = false
              component.generatePDF()
            }
            else{
              component.xlsxDownloading = false
              component.generateXLSX()
            }
          })
          .catch(function (error) {
            console.log(error)
            component.$buefy.toast.open({
              message: error.message,
              type: "is-danger",
            });
          });
    },

    generatePDF: function(){

      var component = this
      var doc = new jsPDF('l', 'px', 'a4')


      var headers = component.reportHeaders

      doc.setFontSize(22)
      doc.text(headers.reportTitle, 30, 30)

      doc.setTextColor(20)
      doc.setFontSize(10)
      doc.text('On ' + headers.reportGeneratedOn + ' by ' + headers.generatedBy , 30, 42)

      doc.setTextColor(0)
      doc.setFontSize(12)
      doc.text('Duration   :  ' + headers.selectedStartDate +' to '+ headers.selectedEndDate , 30, 60)
      // doc.text('User         :  '+ headers.selectedUser, 30, 84)


      doc.setFontSize(11)
      doc.setTextColor(100)

      var col = ['ID', 'Username', 'Name','Contact','Email','Description','Timestamp']
      var rows = [];


      component.tableRows.forEach(element => {
        var temp = [element.id ,element.username, element.name, element.contact_number, element.email, element.description, this.DateFormat(element.timestamp)];
        rows.push(temp);
      });

      doc.setProperties({
        title: headers.reportTitle,
        subject: headers.reportTitle
      });

      autoTable(doc,{
        head:[col],
        body:rows,
        title:headers.reportTitle,
        startY:100
      });

      // doc.autoTable({head:[col], body:rows, title: headers.reportTitle, startY: 100 });

      //doc.output('dataurlnewwindow') // for open in new window
      // var fileNameTimeStamp = headers.reportGeneratedOn.replace(/[ -]/g, '_')
      doc.save(headers.reportFileName + '.pdf') // for download file

    },

    // generateXLSX: function(){
    //
    //   var component = this
    //   var headers = component.reportHeaders
    //
    //   // var table1 = document.querySelector("table");
    //   var opt = {
    //     rowIndex: 9
    //   }; //Start empty 9 lines
    //
    //   var rows = [];
    //
    //   component.tableRows.forEach(element => {
    //     var temp = [element.id ,element.username, element.name, element.contact, element.email, element.description, element.timestamp];
    //     rows.push(temp);
    //   });
    //
    //
    //   var sheet = XLSX2.utils.json_to_sheet(rows,{ origin: "A11" });
    //   XLSX2.utils.sheet_add_aoa(sheet, [['ID', 'Username', 'Name','Contact','Email','Description','Timestamp']], { origin: "A11" });
    //
    //   sheet["A1"] = { //Assign values to A1 cells
    //     t: "s", // cell value type (s: string)
    //     v: headers.reportTitle, // raw value (v)
    //     s: {
    //       font: {
    //         //name: 'Song Style',
    //         sz: 24,
    //         bold: true,
    //         underline: false,
    //         color: {
    //           rgb: "000000"
    //         }
    //       },
    //       alignment: {
    //         horizontal: "left",
    //         vertical: "center",
    //         wrap_text: true
    //       },
    //       // fill: {
    //       //     bgColor: { rgb: 'ffffff' }
    //       // }
    //     }
    //   };
    //
    //   sheet["A4"] = {
    //     t: "s",
    //     v: 'On ' + headers.reportGeneratedOn + ' by ' + headers.generatedBy,
    //   };
    //
    //   sheet["A6"] = { t: "s", v: 'Duration'};
    //   sheet["B6"] = { t: "s", v: headers.selectedStartDate +' to '+ headers.selectedEndDate};
    //
    //   sheet["A8"] = { t: "s", v: 'User'};
    //   sheet["B8"] = { t: "s", v: headers.selectedUser};
    //
    //
    //   if(!sheet["!merges"]){
    //     sheet["!merges"] = []
    //   }
    //   //['!merges'] This property is designed for cell merging
    //   sheet["!merges"].push({//If not null push is null = assign
    //     //Merge cell index starts at 0
    //     s: { //s Start
    //       c: 0, //Beginning column
    //       r: 0 //Start Line
    //     },
    //     e: { //e End
    //       c: 26, //End Column
    //       r: 2 //End line
    //     }
    //   });
    //   sheet["!merges"].push({s: {c: 0, r: 3 }, e: { c: 26, r: 3 }});
    //   sheet["!merges"].push({s: {c: 0, r: 4 }, e: { c: 26, r: 4 }});
    //   sheet["!merges"].push({s: {c: 1, r: 5 }, e: { c: 26, r: 5 }});
    //   sheet["!merges"].push({s: {c: 1, r: 6 }, e: { c: 26, r: 6 }});
    //   sheet["!merges"].push({s: {c: 1, r: 7 }, e: { c: 26, r: 7 }});
    //   sheet["!merges"].push({s: {c: 1, r: 8 }, e: { c: 26, r: 8 }});
    //
    //   sheet['!cols'] = [
    //     {wch:10},
    //     {wch:15},
    //     {wch:10},
    //     {wch:20},
    //     {wch:15}
    //   ];
    //
    //   // var fileNameTimeStamp = headers.reportGeneratedOn.replace(/[ -]/g, '_')
    //   this.openDownloadDialog(sheet2blob(sheet), headers.reportFileName + '.xlsx');
    //
    // },


    openDownloadDialog: function(url, saveName) {
      if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      var aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event;
      if (window.MouseEvent) event = new MouseEvent('click');
      else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    },


    submitForm: function(){

      var component = this
      this.formIsSubmitting = true

      var startd = this.selectedDateRange[0]
      var endd = this.selectedDateRange[1]

      // this is how use date for backend without messing up
      var start_date = startd.getFullYear()+"-"+(startd.getMonth()+1)+"-"+startd.getDate()
      var end_date = endd.getFullYear()+"-"+(endd.getMonth()+1)+"-"+endd.getDate()

      let formData = new FormData()
      formData.append('user_id',component.formData.UserName)
      formData.append('start_date',start_date)
      formData.append('end_date',end_date)
      formData.append('auth_token',component.$root.agentAuthToken,)

      axios.post(component.$base_url+'/agent/generateActivityReport',formData)
          .then(function (response) {
            console.log(response.data.data)
            component.tableRows = response.data.data.reportData
            component.reportHeaders = response.data.data.reportHeaders
            component.formIsSubmitting = false
            component.exportButtonsEnabled = true
          })
          .catch(function (error) {
            component.$buefy.toast.open({
              message: error.message,
              type: 'is-danger'
            })
            component.formIsSubmitting = false
          });

    },

    validateToken:function (){  //check authentication
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },


  },

  mounted (){

    this.validateToken()
    var today = new Date();
    this.maxDate = today

  }
}

</script>

<style scoped>
/* Log Table Styles */

.log-icon-debug{color: #a2a2a2;}

.log-icon-info{color: #1facff;}

.log-icon-notice{color: #f7c200;}

.log-icon-warning{color: #f7c200;}
.log-description-warning{background-color: #fff795;color: #000;}

.log-icon-error{color: #ff0000;}
.log-description-error{color: #ff0000;}

.log-icon-critical{color: #ff0000;}
.log-description-critical{background-color: #f11d1d;color: #FFF;}

.log-icon-alert{color: #ff0000;}
.log-description-alert{background-color: #f11d1d;color: #FFF;}

.log-icon-emergency{color: #ff0000;}
.log-description-emergency{background-color: #f11d1d;color: #FFF;}
</style>

